import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import Constants from '../../../../shared/constants';
import { IconWrapper, Icon } from '../styles';
import { FeedbackListWrapper } from '../../feedback/styles';
import GiggerService from '../../../../services/AdminServices/GiggersService';
import Config from '../../../../config';
import LoadingCard from '../../LoadingCard';
import SearchInput from '../../../../components/Input/SearchInput';
import { getFormattedCSVData } from '../../../../shared/utils';
import Pagination from '../../../../components/Pagination/Pagination';
import ListViewHeader from '../../feedback/ListView/ListViewHeader';
import ListViewBody from '../../feedback/ListView/ListViewBody';

class FeedbackTab extends Component {
  giggerService = new GiggerService(Config.apiBase);

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      feedbackData: [],
      searchbar: true,
      meta: {
        cursor: {
          previous: null,
          current: 0,
          next: 1,
          count: null,
          pageNumber: 1,
          pageSize: 2,
          pages: 1,
        },
      },
      searchQuery: '',
      csvDownloadData: [],
      csvExportFileds: [
        'company_name',
        'company_user_name',
        'feedback',
        'rating',
        'created_at',
        'updated_at',
        'status',
        'user_id',
        'gigger_id',
      ],
    };
  }

  componentDidMount() {
    this.fetchFeedback();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      meta: {
        cursor: { pageNumber },
      },
    } = this.state;
    if (prevState.meta.cursor.pageNumber !== pageNumber) {
      this.fetchFeedback();
    }
  }

  /**
   * Handles pagination
   * @param {Number} pageNumber page number
   */
  handleGotoPage = (pageNumber) => {
    const { meta: { cursor } } = this.state;
    this.setState({
      meta: {
        cursor: {
          ...cursor,
          pageNumber,
        },
      },
    });
  };

  /**
   * Handles search functionality
   * @param {String} value search text
   */
  handlesearchFeedback=(value) => {
    this.setState({ searchQuery: value, searchbar: value.length <= 0 }, () => {
      this.fetchFeedback(value);
    });
  }

  /**
   * Handles Change in search value
   * @param {Event} event search value
   */
  handleSearchOnChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  /**
   * Dowloads data in the form of csv file
   */
  handleDownloadCsv = async () => {
    this.setState({ loading: true });
    const { giggerId } = this.props;
    const { csvExportFileds } = this.state;
    const queryParams = [
      ['export', true],
      ['exportFields', csvExportFileds.toString()],
    ];
    try {
      const response = await this.giggerService.getGiggerFeedback(giggerId, queryParams);
      this.setState({ csvDownloadData: getFormattedCSVData(response.data), loading: false });
      if (response) {
        this.feedbackCsv.link.click();
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  /**
   * Opens complete order modal
   */
  openSearchBar = () => {
    this.setState({ searchbar: false });
  };

  /**
   * Loads data
   */
  handleLoad = () => {
    this.fetchFeedback();
  };

  /**
   * @async
   * @function fetchFeedback Fetches feedback
   * @param {String} searchInput search text
   */
  async fetchFeedback(searchInput) {
    const { giggerId } = this.props;
    const {
      meta: {
        cursor: { pageNumber, pageSize },
      },
      searchQuery,
    } = this.state;
    this.setState({ loading: true });
    const queryParams = [
      ['pageNumber', searchInput ? 1 : pageNumber],
      ['pageSize', pageSize],
      ['search', searchQuery],
    ];
    try {
      const response = await this.giggerService.getGiggerFeedback(giggerId, queryParams);
      const { data = [], meta } = response;
      this.setState({
        loading: false, feedbackData: data, meta,
      });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      feedbackData,
      csvDownloadData,
      searchbar,
      loading,
      searchQuery,
      meta,
    } = this.state;
    return (
      <>
        <CSVLink
          data={csvDownloadData}
          filename="giggerFeedback.csv"
          className="d-none"
          ref={(r) => { this.feedbackCsv = r; }}
        >
          click
        </CSVLink>

        <FeedbackListWrapper>
          <IconWrapper className="row m-0">
            {searchbar ? (
              <Icon src={Constants.icons.SearchIcon} alt="icon" onClick={this.openSearchBar} />
            ) : (
              <div className="text-end col-auto p-0">
                <SearchInput
                  onSearch={this.handlesearchFeedback}
                  onChange={this.handleSearchOnChange}
                  value={searchQuery}
                />
              </div>
            )}
            <Icon
              src={Constants.icons.ExportIcon}
              alt="icon"
              className={feedbackData && feedbackData.length > 0 ? 'mr-3' : 'disableOption mr-3'}
              onClick={this.handleDownloadCsv}
            />
          </IconWrapper>
          {loading && (
            <FeedbackListWrapper>
              <LoadingCard />
            </FeedbackListWrapper>
          )}
          {!loading && (
            <>
              <ListViewHeader gigger />
              <ListViewBody
                data={feedbackData}
                gigger
                handleLoad={this.handleLoad}
                searchQuery={searchQuery}
              />
            </>
          )}
        </FeedbackListWrapper>
        {!loading && meta.cursor.pages > 1 && (
        <FeedbackListWrapper className="bg-transparent">
          <Pagination cursor={meta.cursor} gotoPage={this.handleGotoPage} />
        </FeedbackListWrapper>
        )}
      </>
    );
  }
}

export default FeedbackTab;
